import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import clsx from 'clsx'
import Grow from '@material-ui/core/Grow'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import CardMediaText from '../../components/Card/CardMediaText'

const styles = theme => ({
  card: {
    transition: 'all 0.5s',
    outline: '0 none',
    width: '152px',
    'user-select': 'none',
    cursor: 'pointer',
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      cursor: 'move'
    }
  },
  activeCard: {
    width: '240px',
    marginTop: `-${theme.spacing(3)}px`
  },
  cardContent: {
    lineHeight: '1.5',
    letterSpacing: '0.22px'
  }
})

const PureBenefitCard = ({
  classes,
  intl,
  id,
  img,
  imgAltText,
  index,
  isActive,
  onClick,
  section,
  text,
  title,
  carouselID,
  ...props
}) => {
  const elementId = id && id.replace('#', '')

  return (
    <Card
      key={carouselID}
      id={elementId && `${elementId}-card`}
      className={clsx(classes.card, isActive && classes.activeCard)}
      data-gtm-category="landing_beneficios"
      data-gtm-click="click_carrossel"
      data-gtm-label={elementId && elementId}
      data-gtm-position={`${elementId}_pos${index}`}
      data-gtm-category-ga4="landing_benefits"
      data-gtm-click-ga4="click_carousel"
      data-gtm-label-ga4={intl.formatMessage({ id: title })}
      data-gtm-position-ga4={index+1}
      elevation={isActive ? 9 : 0}
      onClick={() => onClick(section)}
      onFocus={() => onClick(section)}
      onKeyPress={() => onClick(section)}
      tabIndex={0}
      {...props}
    >
      <CardMediaText
        id={elementId && `${elementId}-card-media-text`}
        title={title}
        image={img}
        alt={imgAltText}
        isActive={isActive}
      />
      <Grow in={isActive} timeout={500}>
        <CardContent>
          <Typography
            className={classes.cardContent}
            color="textPrimary"
            component="h3"
            variant="body2"
          >
            <FormattedHTMLMessage id={text} />
          </Typography>
        </CardContent>
      </Grow>
    </Card>
  )
}

PureBenefitCard.propTypes = {
  classes: PropTypes.shape({
    activeCard: PropTypes.string,
    card: PropTypes.string,
    cardContent: PropTypes.string
  }),
  id: PropTypes.string
}

const BenefitCard = withStyles(styles)(injectIntl(PureBenefitCard))

export default BenefitCard
